import { useState } from 'react'

import { RoomDetailsModal } from '@/pages/panel-interno/planning-page/ui/room-details-modal'
import { useSidebarAutoHide } from '@/widgets/sidebar'
import { HotelReservation } from '@monorepo/functions/src/types/reservations'

import { hotel1Layout, hotel2Layout } from '../model/constants/layout'
import { Room } from '../model/room'
import { RoomCard } from './room-card'

interface HotelFloorPlanProps {
    hotelNumber: 1 | 2
    reservations: HotelReservation[]
}

export function HotelFloorPlan({ hotelNumber, reservations }: HotelFloorPlanProps) {
    const [selectedRoom, setSelectedRoom] = useState<Room | null>(null)
    const layout = hotelNumber === 1 ? hotel1Layout : hotel2Layout

    useSidebarAutoHide()

    const handleRoomClick = (room: Room) => {
        setSelectedRoom(room)
    }

    return (
        <div className='h-full w-full'>
            <div className='relative w-full' style={{ paddingTop: hotelNumber === 1 ? '45%' : '35%' }}>
                {layout.map(room => (
                    <RoomCard
                        key={room.id}
                        style={room.style}
                        room={room}
                        onClick={() => handleRoomClick(room)}
                        reservations={reservations}
                    />
                ))}
            </div>
            {selectedRoom && <RoomDetailsModal room={selectedRoom} onClose={() => setSelectedRoom(null)} />}
        </div>
    )
}
